import script from "./loginSignUpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./loginSignUpPage.vue?vue&type=script&setup=true&lang=js"

import "./loginSignUpPage.vue?vue&type=style&index=0&id=b43c3b2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b43c3b2e"]])

export default __exports__